"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkerCard = exports.LocalizedCard = exports.Card = void 0;
var NameLanguage;
(function (NameLanguage) {
    NameLanguage[NameLanguage["en"] = 0] = "en";
    NameLanguage[NameLanguage["de"] = 1] = "de";
    NameLanguage[NameLanguage["es"] = 2] = "es";
    NameLanguage[NameLanguage["fr"] = 3] = "fr";
    NameLanguage[NameLanguage["it"] = 4] = "it";
})(NameLanguage || (NameLanguage = {}));
var Card = /** @class */ (function () {
    function Card(_a) {
        var attributes = _a.attributes, cardDataItem = _a.cardDataItem;
        if (attributes) {
            this.attributes = attributes;
        }
        else if (cardDataItem) {
            var _id = cardDataItem._id, rarity = cardDataItem.rarity, cn = cardDataItem.cn, name = cardDataItem.name, set = cardDataItem.set, expansion = cardDataItem.expansion, onlyFoil = cardDataItem.onlyFoil, locNames = cardDataItem.locNames, rarityStr = cardDataItem.rarityStr, categoryName = cardDataItem.categoryName, expansionReleaseDate = cardDataItem.expansionReleaseDate, colors = cardDataItem.colors;
            this.attributes = [
                _id,
                rarity,
                cn,
                [name, locNames.DE, locNames.ES, locNames.FR, locNames.IT],
                set,
                expansion,
                onlyFoil,
                rarityStr,
                categoryName,
                expansionReleaseDate,
                colors,
            ];
        }
        else {
            throw new Error('invalid parameters');
        }
    }
    Object.defineProperty(Card.prototype, "_id", {
        get: function () {
            return this.attributes[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Card.prototype, "rarity", {
        get: function () {
            return this.attributes[1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Card.prototype, "cn", {
        get: function () {
            return this.attributes[2];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Card.prototype, "name", {
        get: function () {
            return this.attributes[3][NameLanguage.en];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Card.prototype, "set", {
        get: function () {
            return this.attributes[4];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Card.prototype, "expansion", {
        get: function () {
            return this.attributes[5];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Card.prototype, "onlyFoil", {
        get: function () {
            return this.attributes[6];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Card.prototype, "categoryName", {
        get: function () {
            return this.attributes[8];
        },
        enumerable: false,
        configurable: true
    });
    Card.prototype.toPlainObject = function () {
        return {
            _id: this._id,
            rarity: this.rarity,
            cn: this.cn,
            name: this.attributes[3][NameLanguage.en],
            set: this.set,
            expansion: this.expansion,
            onlyFoil: this.onlyFoil,
            locNames: {
                DE: this.attributes[3][NameLanguage.de],
                IT: this.attributes[3][NameLanguage.it],
                ES: this.attributes[3][NameLanguage.es],
                FR: this.attributes[3][NameLanguage.fr],
            },
            rarityStr: this.attributes[7],
            categoryName: this.attributes[8],
            expansionReleaseDate: this.attributes[9],
            colors: this.attributes[10],
        };
    };
    return Card;
}());
exports.Card = Card;
var LocalizedCard = /** @class */ (function (_super) {
    __extends(LocalizedCard, _super);
    function LocalizedCard(params) {
        var _this = _super.call(this, params) || this;
        _this.language = params.language ? NameLanguage[params.language] : NameLanguage.en;
        if (params.cardDataItem) {
            var _a = params.cardDataItem, locNames_1 = _a.locNames, name_1 = _a.name;
            _this.attributes[3] = __spreadArray([
                name_1
            ], ['DE', 'ES', 'FR', 'IT'].map(function (lng) {
                return locNames_1[lng] === name_1 ? '' : locNames_1[lng];
            }), true);
        }
        return _this;
    }
    Object.defineProperty(LocalizedCard.prototype, "name", {
        get: function () {
            return this.attributes[3][this.language] || this.attributes[3][NameLanguage.en];
        },
        enumerable: false,
        configurable: true
    });
    LocalizedCard.prototype.localizedName = function (lang) {
        return this.attributes[3][NameLanguage[lang]] || this.attributes[3][NameLanguage.en];
    };
    Object.defineProperty(LocalizedCard.prototype, "shortLanguage", {
        get: function () {
            return NameLanguage[this.language];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LocalizedCard.prototype, "locNames", {
        get: function () {
            var fallback = this.attributes[3][NameLanguage.en];
            return {
                DE: this.attributes[3][NameLanguage.de] || fallback,
                ES: this.attributes[3][NameLanguage.es] || fallback,
                FR: this.attributes[3][NameLanguage.fr] || fallback,
                IT: this.attributes[3][NameLanguage.it] || fallback,
            };
        },
        enumerable: false,
        configurable: true
    });
    LocalizedCard.prototype.toPlainObject = function () {
        return {
            _id: this._id,
            rarity: this.rarity,
            cn: this.cn,
            name: this.attributes[3][NameLanguage.en],
            set: this.set,
            expansion: this.expansion,
            onlyFoil: this.onlyFoil,
            locNames: this.locNames,
            rarityStr: this.attributes[7],
            categoryName: this.attributes[8],
            expansionReleaseDate: this.attributes[9],
            colors: this.attributes[10],
        };
    };
    return LocalizedCard;
}(Card));
exports.LocalizedCard = LocalizedCard;
var WorkerCard = /** @class */ (function (_super) {
    __extends(WorkerCard, _super);
    function WorkerCard(params) {
        var _this = _super.call(this, params) || this;
        _this.idGame = params.idGame;
        _this.scryfallId = params.scryfallId;
        _this.tcgplayerId = params.tcgplayerId;
        if (params.priceGuideAttr) {
            _this.priceGuideAttr = params.priceGuideAttr;
        }
        else if (params.priceGuide) {
            _this.priceGuideAttr = [
                params.priceGuide.AVG1,
                params.priceGuide.AVG7,
                params.priceGuide.AVG30,
                params.priceGuide.FoilAVG1,
                params.priceGuide.FoilAVG7,
                params.priceGuide.FoilAVG30,
                params.priceGuide.Trend,
                params.priceGuide.FoilTrend,
            ];
        }
        else {
            _this.priceGuideAttr = [
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
            ];
        }
        return _this;
    }
    Object.defineProperty(WorkerCard.prototype, "priceGuide", {
        get: function () {
            return {
                AVG1: this.priceGuideAttr[0],
                AVG7: this.priceGuideAttr[1],
                AVG30: this.priceGuideAttr[2],
                FoilAVG1: this.priceGuideAttr[3],
                FoilAVG7: this.priceGuideAttr[4],
                FoilAVG30: this.priceGuideAttr[5],
                Trend: this.priceGuideAttr[6],
                FoilTrend: this.priceGuideAttr[7],
            };
        },
        enumerable: false,
        configurable: true
    });
    return WorkerCard;
}(Card));
exports.WorkerCard = WorkerCard;
//# sourceMappingURL=Card.js.map